export default __webpack_public_path__ + "static/media/background.d88d5fe7.svg";